module.exports = __webpack_public_path__ + "img/84.8fcf340a.png";